export * from './components/evaluation/evaluation.component';
export * from './evaluation.module';



// WEBPACK FOOTER //
// ./src/app/evaluation/index.ts